import { IconLib } from 'components/Atoms/IconLib'
import styled, { css } from 'styled-components'
import { logos } from 'common'

const designerCSS = css`
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/modal.css */
  .popUpContainer {
    width: 100%;
    min-width: 300px;
    max-width: 600px;
    position: fixed;
    left: 50%;
    top: 50%;
    -webkit-transition: top 0.5s ease;
    -moz-transition: top 0.5s ease;
    -o-transition: top 0.5s ease;
    transition: top 0.5s ease;
    transform: translate(-50%, -50%);
    -webkit-box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    -moz-box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    box-shadow: 0 0 100px rgba(0, 0, 0, 0.4);
    border-radius: 10px;
    z-index: 99;
  }
  article {
    max-height: 800px;
    height: fit-content;
    background-color: hsla(0, 0%, 100%, 0.05);
    backdrop-filter: blur(25px);
    border-radius: 0 0 10px 10px;
    padding: 0 0 0 0;
    display: flex;
    flex-direction: column;
  }
  h1 {
    font-size: 1.2rem;
    font-weight: 600;
    padding: 30px 0 0 30px;
  }
  .popup:target .popUpContainer {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transition: top 0.5s ease;
    -moz-transition: top 0.5s ease;
    -o-transition: top 0.5s ease;
    transition: top 0.5s ease;
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/signin.css */
  .user-signin article {
    padding-bottom: 30px;
  }
  @media (max-width: 600px) {
    .popUpContainer.user-signin {
      max-width: 360px;
    }
    .user-signin article {
      padding-bottom: 30px;
      overflow: visible;
      height: fit-content;
      border-radius: 10px;
    }
    .result_wrapper_mobile {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      width: 100%;
      padding: 30px 30px 0 30px;
    }
    .result_wrapper_mobile h1 {
      text-align: center;
      padding: 0;
      width: 100%;
    }
    .result_wrapper_mobile .yolobot_feature {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin: 20px 0 0 0;
    }
    .result_wrapper_mobile .yolobot_feature .yolobot_logo {
      background: url(${logos.yolobot_logo_2}) center center / 250px auto no-repeat;
      width: 250px;
      height: 65px;
    }

    .result_wrapper_mobile .yolobot_feature .view_docs {
      font-size: 0.8rem;
      margin: 25px 0 0 0;
      display: flex;
      align-items: center;
      flex-direction: column;
    }
    .result_wrapper_mobile .yolobot_feature .view_docs a {
      border-bottom: 1px dotted hsla(0, 0%, 100%, 0.6);
    }
  }
  /*! CSS Used from: http://yolo.tino.me/app_v3/resources/css/res.css */
  article {
    overflow: auto;
    overflow: visible;
    flex-direction: column;
  }
`

const developerCSS = css`
  .result_wrapper_mobile .yolobot_feature a#bot-button {
    background: hsla(0, 0%, 100%, 0.2);
    background: linear-gradient(
      180deg,
      hsla(0, 0%, 100%, 0.2),
      hsla(0, 0%, 96%, 0.2),
      hsla(0, 0%, 91%, 0.2),
      hsla(0, 0%, 87%, 0.2),
      hsla(0, 0%, 83%, 0.2),
      hsla(0, 0%, 79%, 0.2),
      hsla(0, 0%, 75%, 0.2),
      hsla(0, 0%, 71%, 0.2)
    );
    -webkit-backdrop-filter: blur(20px);
    backdrop-filter: blur(20px);
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    line-height: 100%;
    border-radius: 20px;
    padding: 16px 30px 15px 30px;
    font-size: 1rem;
    color: #deff00;
    text-transform: uppercase;
    letter-spacing: -0.02em;
    margin: 20px 0 0 0;
  }
  .result_wrapper_mobile .yolobot_feature a#bot-button strong {
    color: #deff00;
    font-weight: 700;
    padding: 0 0 0 30px;
    margin: 0 0 0 10px;
    background: url(${logos.telegram_logo}) left center / 22px auto no-repeat;
  }
`

export const YolobotSignedUpModalCSS = styled.div`
  ${designerCSS}
  ${developerCSS}
`

export const Close = styled(IconLib).attrs((props) => ({
  collection: 'general',
  name: 'closeOutline',
  dimension: '25px',
}))`
  color: #fff;
  font-size: 1.4rem;
  line-height: 100%;
  position: absolute;
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  left: -8px;
  text-align: center;
  text-decoration: none;
  top: -8px;
  z-index: 1;
  background: rgba(255, 255, 255, 1);

  @media (max-width: 480px) {
    left: -8px;
    top: -8px;
  }
`
